module.exports = __webpack_public_path__ + "svg/account-icon-new.cda15de31788255f773dc5136d8c011e.svg";